export default __webpack_public_path__ + "static/media/laban-400px.7ae12bf3.png";